import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import translations from "../i18n";

interface LanguageContextType {
  lang: string;
  setLang: React.Dispatch<React.SetStateAction<string>>;
  t: (path: string) => string;
}

const LanguageContext = createContext<LanguageContextType | null>(null);

function detectLanguage(): string {
  const saved = localStorage.getItem("lang");
  if (saved && translations[saved]) return saved;

  const browserLang = navigator.language || (navigator as any).userLanguage || "";
  const code = browserLang.toLowerCase().slice(0, 2);
  if (translations[code]) return code;
  return "pl";
}

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<string>(detectLanguage);

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path: string): string => {
    const keys = path.split(".");
    let val: string | Record<string, unknown> | undefined = translations[lang];
    for (const key of keys) {
      if (val && typeof val === "object") val = (val as Record<string, unknown>)[key] as string | Record<string, unknown>;
      else return path;
    }
    return (typeof val === "string" ? val : path);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang(): LanguageContextType {
  return useContext(LanguageContext)!;
}
